import gql from "graphql-tag";

export const reorderKnowledgeBaseItemsMutation = gql`
  mutation reorderKnowledgeBaseItems($parentId: ID, $order: [KnowledgeBaseItemRef!]!) {
    reorderKnowledgeBaseItems(parentId: $parentId, order: $order) {
      id
      name
      parentId
      position
      visibleForDealers
      __typename
    }
  }
`;
